













































import { TableColumn } from "element-ui";
import { ElTable, SortOrder } from "element-ui/types/table";
import { Component, Mixins, Prop, Emit, Vue, Watch } from "vue-property-decorator";
import { ISortParameter } from "../../system";
import { MultiSelectableMixin } from "../../system/selectors/mixins";
import { Comparator } from "../../../domain/system";
import { Header } from "../../../domain/system/table";
import { HisInformationListItem } from "../../../domain/his/HisInformationListItem";
import HisItemComponent from "../components/HisItemComponent.vue";
import HisInfoColumnWidthTable from "./HisInfoColumnWidthTable.vue";
import Enumerable from "linq";

// TODO: 複数選択の動作をListBoxSelectorのようにshiftキーによる範囲選択等ができるようにしたい
@Component({
  components: {
    HisItemComponent,
    HisInfoColumnWidthTable,
  },
})
export default class MultiHisInfoSelector extends Mixins(MultiSelectableMixin) {
  private static readonly sortIconWidth = 20;

  @Prop()
  headers: Header[];
  @Prop()
  multiple: boolean;
  @Prop()
  dateFormat: string;
  @Prop({ default: 50 })
  chunkSizePerPage: number;
  @Prop({ default: 1 })
  currentPage: number;
  @Prop()
  defaultSortParameter: ISortParameter;

  columnFittedWidths: number[];
  columnWidths: number[];
  sortParameter: ISortParameter;

  data(): any {
    return {
      columnFittedWidths: [] as number[],
      columnWidths: [] as number[],
      sortParameter: null,
    };
  }

  $refs!: {
    table: ElTable;
    columnWidthTable: HisInfoColumnWidthTable;
  };

  mounted() {
    if (this.defaultSortParameter) {
      this.applySort(this.defaultSortParameter);
    }
  }

  get visibleHeaders(): Header[] {
    return Enumerable.from(this.headers)
      .where(h => h.isVisible)
      .toArray();
  }

  get displayOptions(): HisInformationListItem[] {
    if (!this.shouldShowPagination) { return this.sortedOptions; }

    return this.sortedOptions.slice(this.chunkSizePerPage * (this.currentPage - 1), this.chunkSizePerPage * this.currentPage);
  }

  get shouldShowPagination(): boolean {
    if (this.chunkSizePerPage == null || this.chunkSizePerPage <= 0) { return false; }

    return (this.chunkSizePerPage < this.sortedOptions.length);
  }

  get sortedOptions(): HisInformationListItem[] {
    if (!this.options || this.options.length === 0) {
      return [];
    }
    if (!this.sortParameter || !this.sortParameter.order) {
      return this.options;
    }
    try {
      const list = this.options
        .slice()
        .map(o => o instanceof HisInformationListItem ? o : null)
        .filter(o => !!o);  // 複製して処理する
      if (list.length === 0) {
        return this.options;
      }
      this.sortList(
        list,
        (i) => {
          const found = i.items.find(v => v.name === this.sortParameter.property);
          return !!found ? found.value : "";
        },
        this.sortParameter.order);

      return list;
    } catch (e) {
      // ここでエラーが発生するとリアクティブの挙動がおかしくなる
      // 対策はしたが、念のためガードしている
      this.$logger.error(e);
    }
    return this.options;
  }

  private sortList(list: HisInformationListItem[], toValue: (s: HisInformationListItem) => number | boolean | string | Date, order: SortOrder): void {
    list.sort((a, b): number => { 
      return Comparator.compare(toValue(a), toValue(b), order === "ascending");
    });
  }

  fitForceColumnWidths(): void {
    this.$refs.columnWidthTable.updateColumnWidths();
    this.columnWidths = this.columnFittedWidths.map(v => v + MultiHisInfoSelector.sortIconWidth);
  }

  onChangedColumnWidth(newValue: number, oldValue: number, { index }: { index: number }): void {
    if (typeof index !== "number") { return; }

    this.columnWidths.splice(index, 1, newValue);
  }

  onSortChanged(param: { column: TableColumn, prop: string, order: SortOrder }): void {
    this.sortParameter = {
      property: param.prop,
      order: param.order,
    };
  }

  resetScrollPosition(): void {
    // ページ遷移が起こった時にスクロールを初期位置に戻す
    const table = this.$refs.table as Vue;
    const wrapper = table.$el.getElementsByClassName("el-table__body-wrapper")[0];
    wrapper.scrollTop = 0;
    wrapper.scrollLeft = 0;
  }

  selectOption(option: HisInformationListItem, event: PointerEvent): void {
    if (this.multiple && event.ctrlKey) {
      this.selectMultiOption(option);
    } else {
      this.selectSingleOption(option);
    }
  }

  selectInputOption(option: HisInformationListItem, event: PointerEvent): void {
    this.selectSingleOption(option);
    this.selectInput();
  }

  @Emit()
  selectInput(): any {}

  @Emit("update:currentPage")
  updateCurrentPage(value: number): any {}

  isSelectedOption(option: HisInformationListItem): boolean {
    return this.selectedOptions.indexOf(option) >= 0;
  }

  getColumnWidth(index: number): number {
    if (this.columnWidths == null) { return 0; }
    if (this.columnWidths.length <= index) { return 0; }

    return this.columnWidths[index];
  }

  private selectMultiOption(option: HisInformationListItem): void {
    this.selectedOptions = this.isSelectedOption(option)
      ? this.selectedOptions.filter(x => x !== option)
      : this.selectedOptions.concat([ option ]);
  }
  
  private selectSingleOption(option: HisInformationListItem): void {
    this.selectedOptions = [ option ];
  }

  @Watch("defaultSortParameter")
  onDefaultSortParameterUpdated(newValue: ISortParameter, oldValue: ISortParameter): void {
    this.$logger.debug("onDefaultSortParameterUpdated()");
    if (!newValue) { return; }
    this.$nextTick(() => {
      this.applySort(newValue);
    });
  }

  applySort(sortParameter: ISortParameter): void {
    this.sortParameter = sortParameter;
    
    const table = this.$refs.table;
    if (!table) { return; }

    if (this.sortParameter) {
      table.sort(this.sortParameter.property, this.sortParameter.order);
    } else {
      table.clearSort();
    }
  }
}
